var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{ref:"header",staticClass:"header",class:{
        'header--collapsed': _vm.collapsed,
        'header--light': _vm.isLight,
        'header--transitioning': _vm.transitioning,
        'header--sticky': _vm.isSticky,
        'navigation--opened': false,
    },attrs:{"data-sc":""}},[_c('div',{ref:"langBanner"},[_c('language-banner',{on:{"show":_vm.stateLanguageBanner}})],1),_vm._v(" "),_c('navigation',{staticClass:"header__navigation hidden nav:block",attrs:{"aria-label":_vm.$t('header.accessible.main')}}),_vm._v(" "),_c('navigation-mobile',{staticClass:"nav:hidden",attrs:{"aria-label":_vm.$t('header.accessible.main')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }